import { render } from "./SingleUserPage.vue?vue&type=template&id=fa0e43ea&scoped=true"
import script from "./SingleUserPage.vue?vue&type=script&lang=js"
export * from "./SingleUserPage.vue?vue&type=script&lang=js"

import "./SingleUserPage.vue?vue&type=style&index=0&id=fa0e43ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0e43ea"]])

export default __exports__